import fetch from './fetch'

/**
 * 获取wx_uid接口
 * @param {Object} params 获取wx_uid接口参数
 * @param {Object} params.code 用户code
 * @param {Object} params.app_id 小程序appid
 */
export const getWxUid = (params) => {
  return fetch.exec('/get_wx_uid', params)
}

/**
 * 获取扎堆文章评论列表
 * @param {Object} params
 * @param {Object} params.article_pk 【必须】文章pk
 * @param {Object} params.last_comment_id 上次评论id（获取下一页评论数据带上）
 * @param {Object} params.main_comment_id 主评论id（查看某个主评论的子评论列表是带上）
 * @param {Object} params.action 【必须 获取列表  all  全部评论列表   mainComment  主评论列表
 * @param {Object} params.page 页码
 */
export const getZdArticleCommentList = (params) => {
  return fetch.exec('/zd_article_comment_list', params)
}

/**
 * 获取扎堆社区评论列表
 * @param {Object} params
 * @param {Object} params.discussion_id 【必须】社区id
 * @param {Object} params.post_id 【必须】帖子pk
 * @param {Object} params.main_comment_id 主评论id（查看某个主评论的子评论列表是带上）
 * @param {Object} params.action 下一页使用next
 * @param {Object} params.sort 排序默认使用asc
 * @param {Object} params.current_num	【必须】下一页必须带上
 */
export const getZdCommunityCommentList = (params) => {
  return fetch.exec('/zd_community_comment_list', params)
}

/**
 * 扎堆文章评论发布
 * @param {Object} params
 * @param {Object} params.article_pk 【必须】评论文章pk
 * @param {Object} params.content 【必须】评论内容
 * @param {Object} params.comment_type 评论类型
 * @param {Object} params.reply_comment_id 回复评论时 被回复评论的id
 * @param {Object} params.main_comment_id 回复评论时候带上，表示回复评论时该评论的主评论id
 * @param {Object} params.reply_uid 回复评论时候带上，表示回复评论时该评论的作者uid
 */
export const ZdArticleCommentPublish = (params) => {
  return fetch.exec('/zd_article_comment_publish', params, { method: 'POST'})
}

/**
 * 扎堆社区评论发布
 * @param {Object} params
 * @param {Object} params.post_id 【必须】帖子pk
 * @param {Object} params.discussion_id 【必须】社区id
 * @param {Object} params.content 内容
 * @param {Object} params.media_ids 多个id用逗号连接
 * @param {Object} params.main_comment_id 回复评论时带上，主评论id
 * @param {Object} params.child_comment_id 回复评论时带上，子评论id
 */
export const ZdCommunityCommentPublish = (params) => {
  return fetch.exec('/zd_community_comment_publish', params, { method: 'POST' })
}

/**
 * 扎堆社区评论删除
 * @param {Object} params
 * @param {Object} params.post_id 【必须】帖子pk
 * @param {Object} params.discussion_id 【必须】社区id
 * @param {Object} params.comment_id 主评论id
 * @param {Object} params.child_comment_id 需要删除的子评论id
 */
export const zdCommunityCommentOption = (params) => {
  return fetch.exec('/zd_community_comment_option', params)
}

/**
 * 扎堆文章评论删除
 * @param {Object} params
 * @param {Object} params.article_pk 【必须】文章pk
 * @param {Object} params.comment_id 【必须】主评论id
 */
export const zdArticleCommentOption = (params) => {
  return fetch.exec('/zd_article_comment_option', params)
}

/**
 * 扎堆文章评论点赞
 * @param {Object} params
 * @param {Object} params.article_pk 【必须】文章pk
 * @param {Object} params.comment_id 【必须】评论id
 * @param {Object} params.action 【必须】add 点赞  remove 移除
 */
export const zdArticleCommentBehavior = (params) => {
  return fetch.exec('/zd_article_comment_behavior', params)
}

/**
 * 扎堆社区评论点赞
 * @param {Object} params
 * @param {Object} params.discussion_id 【必须】社区id
 * @param {Object} params.post_id	 【必须】帖子id
 * @param {Object} params.comment_id 【必须】评论id
 * @param {Object} params.action 【必须】add 点赞  remove 移除
 */
export const zdCommunityCommentBehavior = (params) => {
  return fetch.exec('/zd_community_comment_behavior', params)
}

